export const getLayout = () => {
  const currentWidth = window.innerWidth;
  switch (true) {
    case currentWidth < 800:
      return 'MOBILE';
    default:
      return 'DESKTOP';
  }
};
